module.exports = __webpack_public_path__ + "img/logo.bf7702a9.png";